import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import * as GraphQLTemplatesDatalake from "@/game-lol/graphql-templates-datalake.mjs";
import AugmentsStats from "@/game-lol/models/lol-arena-augments-stats.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

export default function (path: string[], options?: object) {
  return getData(
    queryGQL(appURLs.DATALAKE, GraphQLTemplatesDatalake.ArenaAugmentsStats),
    AugmentsStats,
    path || ["lol", "arenaAugmentsStats"],
    {
      ...(options || {}),
      // shouldFetchIfPathExists: false,
      // expiryTime: Date.now() + 2 * 60 * 60 * 1000, // 2 hours
    },
  );
}
